<template>
  <div>
    <table  class="table editable-table table-striped">
      <thead>
        <tr>
          <th  scope="col" v-for="key in data.cols">
            {{ key.name | capitalize }}
            <span style='display:none' @click="editCol()">[edit]</span> 
            <div v-if="key.type=='select'">
              <select v-model="key.table">
                <option value>Select</option>
                <option v-for="e in tables" v-bind:value="e.Name">{{ e.Name }}</option>
              </select>
              <span>Selected: {{ key.table }}</span>
            </div>
          </th>
          <th>
            
            <button class="btn btn-primary" type="button" v-on:click="addCol()" title="Add Column">+</button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, index) in data.griddata">
          <td v-for="key in data.cols">
            <div v-if="key.type!='select'">
              <input
                :key="index"
                @change="updateCell(entry, key.name,index)"
                v-model="entry[key.name]"
                type="text"
              >
            </div>

            <div v-if="key.type=='select'">
              <select @change="updateCell(entry,  key.name,index)" v-model="entry[key.name]">
                <option value>Select</option>
                <option
                  v-for="e in tables[key.table].griddata"
                  v-bind:value="e.name"
                >{{ e.name }}</option>
              </select>
            </div>
          </td>
          <td>
            <div></div>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="btn btn-primary" type="button" v-on:click="addRow()" title="Add Row">+</button>
    
  </div>
</template>

<script>
// components

// helpers
import db from "@/services/db";
import { log } from "util";

export default {
  props: {
    data: { type: Object, required: true },
    path: { type: String, required: true },
    tables: { type: Object, required: true }
  },
  data(data) {
    return {
      cols: data.cols,
      griddata: data.griddata,
      dpath: this.path,
      model: this.data
    };
  },
  methods: {
    addRow(path) {
      //var tabledata = this.data.griddata;
      // var tablelength = tabledata.length;
      var copytable = {};
       
      var colsmap = this.data.cols

      Object.keys(colsmap).forEach(function(key,index) {
   

        copytable[colsmap[key].name] = "";
        
        


    });
      // console.log(copytable);

      //this.data.griddata.push(copytable)
      var r = db.getRef("widgetsData/" + this.path + "/griddata");
      var newChildRef = r.push(copytable);
      //console.log('my new shiny id is '+newChildRef.key());
    },
    addCol(path) {
      var columnName = prompt("column name");
            var type = prompt("type");
                 var table = prompt("table");
      var colobj = {
              "name" : columnName,
              "table" : table,
              "type" : type
            }
var r = db.getRef("widgetsData/" + this.path + "/cols");

      var newChildRef = r.push(colobj);

      //  this.data.griddata.forEach(function(e) {
      //    console.log(e);

      //    e[columnName] = "";
      //  });

     // db.dbUpdateDataByPath(this.path + "/cols", this.data.cols);
      return "col created";
    },
    updateCell(e, key, i) {
      db.dbUpdateDataByPath(this.path + "/griddata/" + i + "/" + key, e[key]);
      return "cell updated";
    }
  }
};
</script>

<style scoped>
.editable-table  input {
 

    background: none;
    border: none;
    display: block;
    width: 100%;

}
</style>



// WEBPACK FOOTER //
// src/components/DataGrid/index.vue